import React from "react";
import { Button, Menu, Text } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons";
import { useTranslation } from "react-i18next";
import {
  placeholderMarkup,
  placeholdersForTemplateType,
} from "../data/emailPlaceholders";

export default function EmailPlaceholderLegend({
  tokens,
  onInsert,
  form,
  field = "body",
  disabled = false,
  mt = 0,
  mb = 0,
}) {
  const { t } = useTranslation();
  const list =
    tokens || placeholdersForTemplateType(form?.values?.type);

  const insert = (markup) => {
    if (typeof onInsert === "function") {
      onInsert(markup);
      return;
    }
    if (form?.setFieldValue) {
      form.setFieldValue(field, `${form.values?.[field] || ""}${markup}`);
    }
  };

  return (
    <Menu shadow="md" width={280} position="bottom-end" withinPortal>
      <Menu.Target>
        <Button
          type="button"
          variant="default"
          size="sm"
          mt={mt}
          mb={mb}
          disabled={disabled}
          rightIcon={<IconChevronDown size={14} />}
        >
          {t("Placeholder")}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>
          {t("Replaced when the email is sent")}
        </Menu.Label>
        {list.map(({ token, label }) => {
          const markup = placeholderMarkup(token);
          return (
            <Menu.Item key={token} onClick={() => insert(markup)}>
              <Text size="sm">{label}</Text>
              <Text size="xs" color="dimmed">
                {markup}
              </Text>
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
